<template>
    <ul class="img-card-list">
        <li v-for="(item, index) in dataList" :key="index" class="list-item" @click="liClick(item)">
            <div class="list-item-r">
                <img :src="item.img || item.imgs[0]" alt="" class="list-item-img" fit="cover">
                <div v-if="item.createdate" class="list-item-info-date">{{ moment(item.createdate).format('YYYY-MM-DD') }}</div>
            </div>
            <div class="list-item-info">
               <div class="list-item-info-name">{{item.title || item.name || item.realCertSn}}</div>
               <div class="list-item-info-desc2" ref="listItemIntroduction" v-if="item.content" v-html="delHtmlTag(item.content)"></div>
               <div class="list-item-info-desc2" ref="listItemIntroduction" v-else-if="item.comment">
                {{item.comment}}
               </div>
         <!--       <div :class="`list-item-info-desc ${stringOver[index] ? 'list-item-info-desc-over' : ''}`" ref="listItemIntroduction" :title="item.introduction">{{item.introduction}}</div>-->
            </div>
        </li>
        <i></i><i></i>
    </ul>
</template>
<script>
import moment from "moment";
import { delHtmlTag } from "@/utils/index.js";
export default {
  props: ['dataList'],
  data() {
    return {
      stringOver: []
    }
  },
  created(){
  },
  mounted(){
    // this.$nextTick(()=>{
    //     setTimeout(()=>{
    //         this.stringOver = this.dataList.map((e, i) => this.countString(i));
    //     }, 100)
    //     // console.log(888888, this.stringOver)
    // })
  },
  methods: {
    moment,
    delHtmlTag,
    countString(i){
        return (this.$refs.listItemIntroduction && (this.$refs.listItemIntroduction[i].clientHeight > 66));
    },
    liClick(item){
        this.$emit('itemClick', item)
    }
  }
}

</script>
<style lang="less">
.img-card-list{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: stretch;
    i{
        width: 31.6%;
    }
    .list-item{
        width: 31.6%;
        max-width: 380px;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        overflow: hidden;
        &-img{
            height: 206px;
            width: 100%;
            vertical-align: bottom;
            border-radius: 8px 8px 0 0;
        }
        &-info-date{
            color: #B2B2B2;
            line-height: 1;
            padding: 16px 20px 0;
            border-left: 1px solid #E6E6E6;
            border-right: 1px solid #E6E6E6;
            display: inline-block;
            width: 100%;
            box-sizing: border-box;
            position: relative;
        }
        &-info-date::after{
            content: '';
            display: block;
            position: absolute;
            bottom: -16px;
            left: 20px;
            right: 20px;
            border-bottom: 2PX dashed #DDDDDD;
        }
        &-info{
            background: #FFFFFF;
            // opacity: 0.73;
            border: 1px solid #E6E6E6;
            border-top: 0;
            box-sizing: border-box;
            padding: 16px 20px;
            border-radius: 0 0 8px 8px;
            height: 100%;
            &-name{
                // border-top: 2PX dashed #DDDDDD;
                font-size: 18px;
                color: #222222;
                line-height: 1;
                padding: 16px 20px 16px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: keep-all;
                white-space: nowrap;
            }
            &-desc{
                font-size: 16px;
                color: #666666;
                line-height: 1.375;
            }
            &-desc-over, &-desc2, &-desc2 p {
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                position: relative;
                word-break: break-all;
                white-space: normal;
                line-height: 1.5;
            }
            &-desc-over::after{
                content: '[...]';
                display: inline-block;
                color: #FFC40A;
                right: 0;    
                background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 1)  10px);
                bottom: 0;
                position: absolute;
                padding-left: 10px;
            }
        }
    }
}

@media screen and (max-width: 960px){
    .img-card-list{
        .list-item{
            width: 100%;
            max-width: 100%;
            border-radius: 8px;
            overflow: hidden;
            padding-top: .1rem;
            margin-bottom: 0;
            flex-direction: row-reverse;
            border-top: 1px solid #F1F1F1;
            border-radius: unset;
            &-r{
                width: 1.2rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
            &-img{
                width: 1.2rem;
                height: .68rem;
                border-radius: .04rem;
            }
            &-info-date{
                font-size: .12rem;
                text-align: right;
                border: none;
                padding: .1rem 0 .1rem 0;
            }
            &-info{
                flex: 1;
                padding: 0;
                border: none;
                margin-right: .32rem; 
                &-name{
                    padding: 0;
                    max-width: 1.9rem;
                    border: none;
                    font-size: .14rem;
                    line-height: .22rem;
                    margin-bottom: .04rem;
                }
                &-desc, &-desc2{
                    font-size: .12rem;
                }
            }
        }
        .list-item:first-child{
            border: none;
        }
    }
}
</style>